import restClient from "../restClient";

export const createDashboard = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    const response = await restClient.post(`dashboards`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getDashboards = async (params) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params
    };
    const response = await restClient.get(`dashboards`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateDashboard = async ({ id, data }) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    const response = await restClient.put(`dashboards/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteDashboard = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    const response = await restClient.delete(`dashboards/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

